import { Button } from 'flowbite-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { baseUrl } from '../config';



export function PreProductionContent() {
  return (
    <div className='p-3'>
      <h3 className='font-bold pb-3'>What is pre-production</h3>
      <p>
      Pre-production is a crucial phase in filmmaking that takes place before the cameras start rolling. 
      It's a detailed and collaborative process 
      where all the creative and logistical groundwork is laid to ensure the production runs smoothly.
      Here’s a closer look at what happens during pre-production:
      </p>
      <div className="mt-3">
        <p className=" font-bold">Script Finalization</p>
        <p>The script is refined, with detailed revisions made to ensure clarity in storytelling. Writers and directors may collaborate to fine-tune dialogue, scenes, and pacing. Additionally, a breakdown of the 
          script is done to identify all the necessary elements such as props, locations, actors, and special effects.
        </p>
        <Link className="/promotions"><p>Want to know how it works?</p></Link>
      </div>
      <div className="mt-3">
        <p className=" font-bold">Budgeting and Financing</p>
        <p>Once the script is finalized, producers work closely with line producers or production managers to create a detailed budget. This covers costs for actors, crew, equipment, sets, locations, special effects, and post-production.
           Securing financing and making necessary deals with investors or studios also occurs during this phase.
        </p>
        <Link className="/promotions"><p>Want to know how it works?</p></Link>
      </div>
      <div className="mt-3">
        <p className=" font-bold">Casting</p>
        <p>Casting directors organize auditions to select the right actors for each role. This includes lead roles, supporting characters, and background extras.
           Directors are often involved in the casting decisions, ensuring that the chosen actors fit their creative vision.
        </p>
        <Link className="/promotions"><p>Want to know how it works?</p></Link>
      </div>
      <Link to='/promotions'><p className='text-blue-600 underline mt-4 cursor-pointer'>Learn more</p></Link>
      <Link to='/stages' ><Button  color='dark' className="mt-4">No thanks, take me to the page</Button></Link>
    </div>
  );
}
